import { query, collection, getDocs, where } from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import CommonHeadings from "helper/constant/headings";
import Dateformat from "helper/constant/timeFormat";
import TableName from "helper/tableName/tableName";
import moment from "moment";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useLayoutEffect, useState } from "react";
import Moment from "react-moment";
import { useLocation } from "react-router-dom";

function TransactionData() {
    const [studentTransactionData, setStudentTransactionData] = useState([]);
    const location = useLocation();

    // MARK: use Effect function
    useEffect(() => {
        fetchStudentsFeeApi();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useLayoutEffect(() => {
        document.title = CommonHeadings.transactionHistory
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const monthDateFormat = (regularStudents) => {
        return moment(regularStudents.month_timestamp).format(Dateformat.MMMMYYYY)
    };

    const studentAdmissionDate = () => {
        if (location.state.rejoin_date === "Invalid date") {
            return <Moment format={Dateformat.DDMMYYYY}>{location.state.admission_date}</Moment>
          }
          
          if(location.state.rejoin_date) {
            return <Moment format={Dateformat.DDMMYYYY}>{location.state.rejoin_date}</Moment>
          } else if (location.state.admission_date)  {
            return <Moment format={Dateformat.DDMMYYYY}>{location.state.admission_date}</Moment>
          } else {
            return "NA"
          }
    };

    //MARK: Student Name
    const studentName = () => {
        return (
            <>
                    <div className="row">
                        <div className="col-4">
                            <p className="table__column__capital ms-0">Student Name: <span>{location.state.name}</span></p>
                        </div>
                        <div className="col-4">
                            <p className="ms-5">Admission Number: <span>{location.state.admission_no}</span></p>
                        </div>
                        <div className="col-4">
                            <p className="ms-5">Admission Date: 
                                <span> {studentAdmissionDate()}</span></p>
                        </div>
                    </div>

            </>
        );
    };

    const header = studentName();

    // MARK:students columns data
    const studentsColumns = [
        {
            field: "amount",
            header: "Amount",
            CardBody: priceBodyTemplate
        },
        {
            field: "month",
            header: "Month",
            CardBody: monthDateFormat
        },
        {
            field: "payment_method",
            header: "Payment Method",
            className: "table__column__capital",
        },
        {
            field: "fees_date",
            header: "Payment Date",
            CardBody: (data) => (<Moment format={Dateformat.DDMMYYYY}>{data.fees_date}</Moment>),
        }
    ];

    // MARK: fetch API
    async function fetchStudentsFeeApi() {
        const getStudentId = location.state.id;
        let q = query(
            collection(dbFirestore, TableName.fee), where("student_id", "==", getStudentId)
        );
        const querySnapshot = await getDocs(q);
        const array = querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
        setStudentTransactionData(array);
    }

    return (
        <div className="modules__main__div mt-5">
            <div className="col-12">
                <div className="card modules__card">

                    <DataTable
                        className="mt-5 mb-3"
                        value={studentTransactionData} header={header}
                        emptyMessage="No data found."
                    >
                        {studentsColumns.map((col) => (
                            <Column
                                key={col.field}
                                field={col.field}
                                header={col.header}
                                bodyClassName={col.className}
                                body={col.CardBody}
                            />
                        ))}
                    </DataTable>

                </div>
            </div>
        </div>
    )
}

const priceBodyTemplate = (student) => {
    return `Rs ${student.amount?.toLocaleString()}`;
};

export default TransactionData;